import { render, staticRenderFns } from "./SelfAssessmentEmploymentPolicies.vue?vue&type=template&id=2aed8524&scoped=true&"
import script from "./SelfAssessmentEmploymentPolicies.vue?vue&type=script&lang=js&"
export * from "./SelfAssessmentEmploymentPolicies.vue?vue&type=script&lang=js&"
import style0 from "./SelfAssessmentEmploymentPolicies.vue?vue&type=style&index=0&id=2aed8524&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aed8524",
  null
  
)

export default component.exports